// LivePresenceCounter — conteo en vivo de Landing/Tienda/Clientes.
// Antes vivía dentro del sidebar admin; ahora se renderiza dentro de
// /admin/infraestructura como tarjeta. Aceptamos variant 'card' (default)
// y 'sidebar' por si alguna vez se vuelve a meter en una barra lateral.

import { useWatchPresence } from '../lib/presence'

export default function LivePresenceCounter({ variant = 'card' }) {
  const counts = useWatchPresence(['presence:landing', 'presence:tienda', 'presence:cliente'])
  const landing = counts['presence:landing'] || 0
  const tienda = counts['presence:tienda'] || 0
  const cliente = counts['presence:cliente'] || 0
  const total = landing + tienda + cliente

  if (variant === 'sidebar') {
    return (
      <div className="lpc-sidebar" title={total > 0 ? `${total} ${total === 1 ? 'persona' : 'personas'} ahora mismo` : 'Nadie navegando ahora'}>
        <div className="lpc-sidebar-head"><span className="lpc-pulse"></span>En vivo</div>
        <Row icon="🌐" label="Landing" n={landing} />
        <Row icon="🛒" label="Tienda" n={tienda} />
        <Row icon="👤" label="Clientes" n={cliente} />
        <Estilos />
      </div>
    )
  }

  return (
    <section className="lpc-card">
      <header className="lpc-card-head">
        <h2><span className="lpc-pulse"></span> En vivo · ahora mismo</h2>
        <p>Visitantes navegando los sitios de Limpack en tiempo real. Realtime via Supabase Presence.</p>
      </header>
      <div className="lpc-grid">
        <Tile icon="🌐" label="Landing"  sub="limpack.uy"          n={landing} color="#1A3461" />
        <Tile icon="🛒" label="Tienda"   sub="tienda.limpack.uy"   n={tienda}  color="#00A8B5" />
        <Tile icon="👤" label="Clientes" sub="panel · clientes"    n={cliente} color="#5BBDD8" />
        <Tile icon="🟢" label="Total"    sub="ahora mismo"         n={total}   color="#16A34A" highlight />
      </div>
      <Estilos />
    </section>
  )
}

function Row({ icon, label, n }) {
  return (
    <div className={`lpc-sidebar-row ${n === 0 ? 'zero' : ''}`}>
      <span>{icon} {label}</span>
      <span className="lpc-sidebar-num">{n}</span>
    </div>
  )
}

function Tile({ icon, label, sub, n, color, highlight }) {
  return (
    <div className={`lpc-tile ${highlight ? 'hl' : ''}`} style={{ '--lpc-color': color }}>
      <div className="lpc-tile-icon">{icon}</div>
      <div className="lpc-tile-n">{n}</div>
      <div className="lpc-tile-l">{label}</div>
      <div className="lpc-tile-s">{sub}</div>
    </div>
  )
}

function Estilos() {
  return (
    <style>{`
      /* Card variant — para /admin/infraestructura */
      .lpc-card {
        background: #fff; border: 1px solid #E2E8F0; border-radius: 12px;
        padding: 18px 22px; margin-bottom: 14px;
      }
      .lpc-card-head { margin-bottom: 14px }
      .lpc-card-head h2 {
        margin: 0 0 4px; font-size: 15px; font-weight: 800; color: #1A3461;
        display: flex; align-items: center; gap: 8px;
      }
      .lpc-card-head p { margin: 0; font-size: 12.5px; color: #64748B; line-height: 1.5 }
      .lpc-grid {
        display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 10px;
      }
      .lpc-tile {
        background: #F8FAFC; border: 1px solid #E2E8F0; border-radius: 10px;
        padding: 14px 16px; position: relative;
      }
      .lpc-tile.hl { background: linear-gradient(135deg, rgba(22,163,74,.10), rgba(0,168,181,.06)); border-color: rgba(22,163,74,.25) }
      .lpc-tile-icon { font-size: 18px; opacity: .8 }
      .lpc-tile-n {
        font-size: 28px; font-weight: 900; color: var(--lpc-color, #1A3461);
        line-height: 1.1; margin-top: 4px;
      }
      .lpc-tile-l { font-size: 12px; font-weight: 800; color: #1A3461; margin-top: 4px; text-transform: uppercase; letter-spacing: .04em }
      .lpc-tile-s { font-size: 11px; color: #94A3B8 }

      /* Sidebar variant — fondo oscuro */
      .lpc-sidebar {
        margin: 10px 14px 14px; padding: 10px 12px;
        background: rgba(16,185,129,.06);
        border: 1px solid rgba(16,185,129,.18);
        border-radius: 10px; font-size: 11px;
      }
      .lpc-sidebar-head {
        display: flex; align-items: center; gap: 6px;
        font-weight: 700; color: #10B981; letter-spacing: .04em;
        text-transform: uppercase; font-size: 10px; margin-bottom: 8px;
      }
      .lpc-sidebar-row {
        display: flex; justify-content: space-between; align-items: center;
        padding: 3px 0;
      }
      .lpc-sidebar-num {
        font-weight: 800; color: #1A3461;
        background: rgba(0,168,181,.08);
        padding: 1px 7px; border-radius: 999px;
        font-size: 11px; min-width: 22px; text-align: center;
      }
      .lpc-sidebar-row.zero .lpc-sidebar-num { background: rgba(100,116,139,.08); color: #64748B }

      /* Pulse común a las dos variantes */
      .lpc-pulse {
        width: 8px; height: 8px; border-radius: 50%;
        background: #10B981; box-shadow: 0 0 0 0 rgba(16,185,129,.6);
        animation: lpcPulse 2s infinite; display: inline-block;
      }
      @keyframes lpcPulse {
        0%   { box-shadow: 0 0 0 0 rgba(16,185,129,.6); }
        70%  { box-shadow: 0 0 0 8px rgba(16,185,129,0); }
        100% { box-shadow: 0 0 0 0 rgba(16,185,129,0); }
      }
    `}</style>
  )
}
